import { connect } from 'react-redux';

import { commonErrorsSelector } from 'src/store/touristsValidation/selectors';
import { getTouristsCount } from 'checkout/store/selectors/package';

import { ValidationErrorsList } from 'src/components/ValidationErrorsList';

const mapStateToProps = (state) => {
  const touristsCount = getTouristsCount(state);

  return {
    errors: commonErrorsSelector(state, touristsCount),
  };
};

export default connect(mapStateToProps)(ValidationErrorsList);
